import { Length } from '@frontend/Units';
import { getSettings, getUser, getUserSessionInfo } from '@phi/frontend/api/calls';
import { IFrontendServiceContainer } from '@phi/frontend/service-container';
import { LOG, display_message_to_user } from '@phi/logging/frontend';
import { LengthUnit, UnitConfiguration } from '@phi/onshape';
import { pipe } from '@vaaas/fpts/function';
import { ofKV } from '@vaaas/fpts/object';

const ONSHAPE_LENGTH_MAP: Record<LengthUnit, Length> = {
    meter: Length.m,
    centimeter: Length.cm,
    millimeter: Length.mm,
    yard: Length.yd,
    foot: Length.ft,
    inch: Length.in,
};

export const authenticate_through_onshape_provider = (app: IFrontendServiceContainer) => async () => {
    await Promise.all([
        getUser().then(x => {
            if (x instanceof Error)
                return undefined;
            app.state.user = x;
            Object.assign(app.settings, x.settings);
        }),

        getUserSessionInfo().then((x) => {
            if (x instanceof Error)
                display_message_to_user(LOG.ERROR, 'Failed to get user session info');
            else
                app.state.session = x;
        }),

        getSettings().then(settings => {
            if (settings instanceof Error) {
                display_message_to_user(LOG.WARN, 'Failed to get OnShape settings');
                return {};
            }
            const units = pipe(
                settings.defaultUnits.units,
                ofKV((x: UnitConfiguration) => x.key)(x => x.value),
            );
            if (units.LENGTH)
                app.state.onshape_default_length = ONSHAPE_LENGTH_MAP[units.LENGTH as LengthUnit];
        }),

        app.authentication.validate_session(),
    ]);
};
